var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-width"},[_c('div',{staticClass:"left"},[_c('h2',{staticClass:"page-title",class:{cn: _vm.isLangCN },domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('AppSearchInput')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }